import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Search, Filter } from "lucide-react";
import DatePickerInput from "@/components/DatePickerInput";

const TYPE_OPTIONS = [
  { value: "all", label: "Semua" },
  { value: "ndp", label: "NDP" },
  { value: "regis", label: "Regis" },
];

const PRESETS = [
  { key: "today", label: "Hari Ini" },
  { key: "yesterday", label: "Kemarin" },
  { key: "this_week", label: "Minggu Ini" },
  { key: "this_month", label: "Bulan Ini" },
];

export const ToDoFilterBar = ({
  members,
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onPreset,
  onApply,
  onReset,
}) => {
  const counts = {
    all: members.length,
    ndp: members.filter((m) => m.member_type === "ndp").length,
    regis: members.filter((m) => m.member_type === "regis").length,
  };

  return (
    <>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
          <Input
            placeholder="Cari member..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 bg-[#0f0f10] border-red-900/30 text-white"
            data-testid="search-input"
          />
        </div>
      </div>

      {/* Type filter as pill buttons */}
      <div className="mt-4">
        <Label className="text-gray-300 mb-2 block">Tipe Member</Label>
        <div className="flex flex-wrap gap-2">
          {TYPE_OPTIONS.map((opt) => (
            <Button
              key={opt.value}
              onClick={() => setFilterType(opt.value)}
              variant={filterType === opt.value ? "default" : "outline"}
              size="sm"
              className={
                filterType === opt.value
                  ? "bg-red-600 hover:bg-red-700 text-white"
                  : "border-red-900/30 text-white hover:bg-red-900/20"
              }
              data-testid={`filter-type-${opt.value}`}
            >
              <Filter size={14} className="mr-1.5" />
              {opt.label}
              <span className="ml-2 px-2 py-0.5 rounded-full text-xs bg-black/30">
                {counts[opt.value]}
              </span>
            </Button>
          ))}
        </div>
      </div>

      {/* Date filter */}
      <div className="mt-4 p-4 rounded-lg border border-red-900/30 bg-[#0f0f10]/50">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-gray-300 mb-2 block">Dari Tanggal</Label>
            <DatePickerInput
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="todo-start-date"
            />
          </div>
          <div>
            <Label className="text-gray-300 mb-2 block">Sampai Tanggal</Label>
            <DatePickerInput
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="todo-end-date"
            />
          </div>
        </div>
        <div className="mt-4">
          <Label className="text-gray-300 mb-2 block">Preset Tanggal</Label>
          <div className="flex flex-wrap gap-2">
            {PRESETS.map((p) => (
              <Button
                key={p.key}
                onClick={() => onPreset(p.key)}
                variant="outline"
                size="sm"
                className="border-red-900/30 text-white hover:bg-red-900/20"
                data-testid={`todo-preset-${p.key === "this_week" ? "week" : p.key === "this_month" ? "month" : p.key}`}
              >
                {p.label}
              </Button>
            ))}
          </div>
        </div>
        <div className="mt-4 flex gap-2">
          <Button
            onClick={onApply}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="todo-apply-filter"
          >
            <Search size={16} className="mr-2" /> Terapkan Filter
          </Button>
          <Button
            onClick={onReset}
            variant="outline"
            className="border-red-900/30 text-white hover:bg-red-900/20"
            data-testid="todo-reset-filter"
          >
            Reset
          </Button>
        </div>
      </div>
    </>
  );
};

export default ToDoFilterBar;
